
import { useRef, useState, useEffect } from "react";
import NumberInput from "../../../components/UIComponent/NumberInput";
import moment from "moment";
import RadioButton from "../../../components/membership/membershipTaskList/RadioButton";

function CpdSubmission(props) {
  const textRef = useRef();
  const [ value ] = useState();

  useEffect(() => {

  }, []);



  return (
    <div className="w-full organisation-basic-information">
      <div className="col-span-12">
        <div className="form-info-title">
          <h4 className="text-[#2d2d2d] small-title font-bold theme-color">
            CPD Submission Details
          </h4>
        </div>
      </div>

      <div className="grid grid-cols-12 md:gap-4 gap-3 w-full justify-between mt-3 mb-3">

        {/* Total Number of CPD Approved */}
        <div className="lg:col-span-3 col-span-12">
          <h2 className="input-title mb-3">
            Carry Forward Points
          </h2>
          <div className="dropdown">
            <NumberInput
              name="availableCarryForwardPoints"
              value={props.cpdSubmissionDetailsObj?.availableCarryForwardPoints}
              handleChange={(e) =>
                props.handleChange(e, "CpdSubmission")
              }
              onBlur={() => { }}
              disabled={true}
              className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
            />
          </div>
        </div>
        <div className="lg:col-span-3 col-span-12">
          <h2 className="input-title mb-3">
            Approved CPD for This Year
          </h2>
          <div className="dropdown">
            <NumberInput
              name="curruntTotalApprovedCPD"
              value={props.cpdSubmissionDetailsObj?.curruntTotalApprovedCPD}
              handleChange={(e) =>
                props.handleChange(e, "CpdSubmission")
              }
              onBlur={() => { }}
              disabled={true}
              className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
            />
          </div>
        </div>
        <div className="lg:col-span-3 col-span-12">
          <h2 className="input-title mb-3">
            Target Points This Year
          </h2>
          <div className="dropdown">
            <NumberInput
              name="requiredPointsForNextRenewal"
              value={props.cpdSubmissionDetailsObj?.requiredPointsForCurruntRenewal}
              handleChange={(e) =>
                props.handleChange(e, "CpdSubmission")
              }
              onBlur={() => { }}
              disabled={true}
              className="bg-gray-100 text-gray-500 border-black cursor-not-allowed"
            />
          </div>
        </div>
        <div className="lg:col-span-3 col-span-12 input-sec-texts company-type">
          <h2 className="input-title mb-3">
            Benefit Lapsed Used
            <span className="text-[#C00000]"> *</span>
          </h2>

          <div className="flex items-center w-full">
            <div className="flex items-center">
              <RadioButton
                id="isLapseBenefitUsed"
                name="isLapseBenefitUsed"
                className="form-radio-caps"
                value={true}
                checked={props.cpdSubmissionDetailsObj?.isLapseBenefitUsed === true}
                handleRadioButtons={(e) =>
                  props.handleChange(e, "Benefit_radio")
                }
                isDisabled={true}
              />
              <span className="ml-3">Yes</span>
            </div>
            <div className="flex items-center ml-10">
              <RadioButton
                id="isLapseBenefitUsed"
                name="isLapseBenefitUsed"
                className="form-radio-caps"
                value={false}
                checked={
                  props.cpdSubmissionDetailsObj?.isLapseBenefitUsed === false
                }
                handleRadioButtons={(e) =>
                  props.handleChange(e, "Benefit_radio")
                }
                isDisabled={true}
              />
              <span className="ml-3">No</span>
            </div>
          </div>
        </div>
      </div>
      <div className="form-info-title">
        <h2 className="input-title mb-3">
          List of history records CPD Submission
        </h2>

      </div>
      <div className="col-span-12 ">
        <div className="mb-2"></div>
        <div className="table-section">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead className="bg-[#005b9c] text-white">
                <tr>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    CPD Status
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    ACP Name
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    Registration Number
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    ACP ContactNumber
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    Activity Type
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    Claim Point
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    Approved Points
                  </th>
                  <th className="text-left py-3 lg:px-5 px-2 whitespace-nowrap w-[9%]">
                    Approved Date
                  </th>
                </tr>
              </thead>
              <tbody className="text-sm custom-tbody">
                {props?.cpdSubmissionDetails?.length > 0 ? (
                  props.cpdSubmissionDetails.map((cpdHistory, key) => (
                    <tr
                      className="bg-[#eeeeee] text-black border-t-4 border-[#ffffff]"
                      key={key}
                    >
                      <td className="text-left py-2 px-5">
                        {cpdHistory.cpdStatus}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.acpName}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.acpRegistrationNumber}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.acpContactNumber}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.acpActivity}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.claimPoints}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.approvedPoints}
                      </td>
                      <td className="text-left py-2 px-5">
                        {cpdHistory.approvalDate ? moment(cpdHistory.approvalDate).format('DD MMM YYYY')
                          : ''}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="8" className="text-center py-3">
                      No CPD records found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CpdSubmission;